import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66063526"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "booking-success-page" }
const _hoisted_2 = { class: "header-wrapper" }
const _hoisted_3 = { class: "title-2" }
const _hoisted_4 = { class: "text-2" }
const _hoisted_5 = { class: "content-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title-2 content-title" }, "予約内容", -1))
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "text-value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title-2 content-title" }, "予約内容", -1))
const _hoisted_10 = {
  key: 0,
  class: "label"
}
const _hoisted_11 = { class: "text-value" }
const _hoisted_12 = {
  key: 1,
  class: "label"
}
const _hoisted_13 = { class: "text-value" }
const _hoisted_14 = {
  key: 2,
  class: "label"
}
const _hoisted_15 = { class: "text-value" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "text-value total-price" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "text-value total-price" }
const _hoisted_20 = { class: "footer-wrapper" }

import liff from "@line/liff";
import { useStore } from "vuex";
import { onBeforeMount, computed, ref } from "vue";
import moment from "moment";
import NumberUtils from "@/clinic/utils/number-utils";
import DateTimeUtils from "@/customer/utils/date-time-utils";
import RouterUtils from "@/common/utils/router.util";
import RouterConstants from "../constants/router.constants";
import AppConstants from "@/common/constants/app.constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingSuccess',
  setup(__props) {

moment.locale("ja");

const store = useStore();
const bookingType = ref(store.getters["booking/selectedMenu"]?.bookingType);
const bookedDate = computed(() => {
  return `${moment(store.getters["booking/selectedTime"].date).format("YYYY年MM月DD日(ddd)")} ${
    store.getters["booking/selectedTime"].time
  }`;
});

const closeBtnText = computed(() => {
  if (liff.isInClient()) {
    return "閉じる";
  } else {
    return "トップページへ戻る";
  }
});

const backToTop = () => {
  store.commit("booking/resetState");
  if (liff.isInClient()) {
    liff.closeWindow();
  } else {
    RouterUtils.goToWithQuery(RouterConstants.BOOKING_ROUTER_NAME, {
      clinic_id: store.getters["line_account/clinicId"],
    });
  }
};

onBeforeMount(async () => {
  if (store.getters["booking/submited"] == false) {
    RouterUtils.goToWithQuery(RouterConstants.BOOKING_ROUTER_NAME, {
      clinic_id: store.getters["line_account/clinicId"],
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(bookingType.value != "request" ? "予約が完了しました" : "リクエスト予約が完了しました"), 1),
      _createElementVNode("h5", _hoisted_4, _toDisplayString(bookingType.value != "request"
            ? "ご予約ありがとうございます。"
            : "予約日が確定したらLINEでご連絡させていただきます。 もしご連絡がないようでしたらお手数ですが、お電話にて直接お問合せください。"), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (bookingType.value != 'request')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, [
              _createTextVNode(" 予約日時： "),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(bookedDate)), 1)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_9,
            (_unref(store).getters['booking/selectedRequestDates']?.first)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                  _createTextVNode(" 第一希望： "),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(moment)(_unref(store).getters["booking/selectedRequestDates"]?.first).format("YYYY年MM月DD日 HH:mm")), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(store).getters['booking/selectedRequestDates']?.second)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                  _createTextVNode(" 第二希望： "),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(moment)(_unref(store).getters["booking/selectedRequestDates"]?.second).format("YYYY年MM月DD日 HH:mm")), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(store).getters['booking/selectedRequestDates']?.third)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                  _createTextVNode(" 第三希望： "),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(moment)(_unref(store).getters["booking/selectedRequestDates"]?.third).format("YYYY年MM月DD日 HH:mm")), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64)),
      _createElementVNode("p", _hoisted_16, [
        _createTextVNode(" 所要時間目安："),
        _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(DateTimeUtils).convertMinutesToHoursAndMinutes(_unref(store).getters["booking/totalTime"])), 1)
      ]),
      _createElementVNode("p", _hoisted_18, [
        _createTextVNode(" お支払い予定金額："),
        _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(NumberUtils).formatJPCurrency(_unref(store).getters["booking/totalPrice"])), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_Button, {
        class: "back-to-top-btn",
        onClick: backToTop
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(closeBtnText)), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})